import * as Immutable from 'seamless-immutable';
import {
  PUSHPIN_ATTRIBUTES_SET,
  ISSUE_CREATE_API_FULFILLED,
  VIEWER_PUSHPIN_THUMBNAIL_CREATED,
  PUSHPIN_THUMBNAIL_UPLOADED,
  PUSHPIN_THUMBNAIL_CLEAR_PENDING
} from '../actions';
import lodashGet from 'lodash/get';

const addPendingThumbnail = (pendingThumbnails, pushpinId) =>
  pendingThumbnails.merge({[pushpinId]: {issueId: null, snapshotUrn: null}});

const issueSnapshotReducerInitialState = Immutable.from({
  pendingThumbnails: {}
});

export default (state = issueSnapshotReducerInitialState, action) => {
  switch (action.type) {
    case VIEWER_PUSHPIN_THUMBNAIL_CREATED: {
      const {pushpinAttributes, issueId} = action.payload;

      if (!issueId && !state.pendingThumbnails[pushpinAttributes.id]) {
        return state.merge({pendingThumbnails: addPendingThumbnail(state.pendingThumbnails, pushpinAttributes.id)});
      }

      return state;
    }
    case PUSHPIN_ATTRIBUTES_SET: {
      const {attributes} = action.payload;

      if (attributes === null || !attributes.isNew) {
        return state;
      }

      return state.merge({pendingThumbnails: addPendingThumbnail(state.pendingThumbnails, attributes.id)});
    }
    case ISSUE_CREATE_API_FULFILLED: {
      const issue = action.payload;
      const issuePushpinId = lodashGet(action, 'meta.issuePushpinId');

      if (!issuePushpinId) {
        return state;
      }

      // Attach issue ID to pending thumbnail
      if (state.pendingThumbnails[issuePushpinId]) {
        return state.setIn(['pendingThumbnails', issuePushpinId, 'issueId'], issue.id);
      }

      return state;
    }
    case PUSHPIN_THUMBNAIL_UPLOADED: {
      // Attach snapshotUrn to pending thumbnail
      const {pushpinId, snapshotUrn} = action.payload;

      if (state.pendingThumbnails[pushpinId]) {
        return state.setIn(['pendingThumbnails', pushpinId, 'snapshotUrn'], snapshotUrn);
      }

      return state;
    }
    case PUSHPIN_THUMBNAIL_CLEAR_PENDING:
      // Remove pending thumbnail data
      const pendingThumbnails = state.pendingThumbnails.without(action.payload);

      return state.merge({pendingThumbnails});
    default:
      return state;
  }
};
